import { render, staticRenderFns } from "./StudentProfileLinks.vue?vue&type=template&id=b380c9d8&"
import script from "./StudentProfileLinks.vue?vue&type=script&lang=js&"
export * from "./StudentProfileLinks.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports